export default __webpack_public_path__ + "static/media/2.71290973.png";